import React from 'react';
import { useSelector } from 'react-redux';
import { PERSONA_TYPES, SharedRootStore } from '@cowbell/data';
import { useAuth } from './useAuth';
import { useAllow } from './useAllow';

const selectActorUser = (state: SharedRootStore) => state.user;
const selectActorAccount = (state: SharedRootStore) => state.user_account;

export type UseActorReturn = ReturnType<typeof useActor>;

export const useActor = () => {
  const { accountType, subscriberType } = useAuth();
  const user = useSelector(selectActorUser);
  const account = useSelector(selectActorAccount);
  const isAdminUser = useAllow('role:admin');
  const isPatraUser = useAllow('role:operator') && !isAdminUser;

  return React.useMemo(
    () => ({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(user as any),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      account: account as any,
      isPatraUser,
      subscriberType,
      isCowbell: accountType === PERSONA_TYPES.COWBELL,
      isAgency: accountType === PERSONA_TYPES.AGENCY,
      isInsured: accountType === PERSONA_TYPES.CUSTOMER,
      isDigital: accountType === PERSONA_TYPES.DIGITAL,
      isMssp: accountType === PERSONA_TYPES.MSSP,
      isCarrier: accountType === PERSONA_TYPES.CARRIER,
      isCluster: accountType === PERSONA_TYPES.CLUSTER,
      isVendor: accountType === PERSONA_TYPES.VENDOR,
      isPool: accountType === PERSONA_TYPES.POOL,
    }),
    [user, account, accountType, subscriberType, isPatraUser]
  );
};
